<template>
  <alzata-dialog
    ref="modal"
    :title="user ? 'Edit User' : 'Create User'"
    seamless
  >
    <div class="row mt-n4">
      <div class="col-12">
        <alzata-tabs toEdge ref="tabContainer">
          <alzata-tab title="Basic Info">
            <div class="row g-2">
              <div class="form-group mb-2">
                <div class="row">
                  <div class="col">
                    <label for="firstName" class="form-label"
                      >First Name: <alzata-required-indicator
                    /></label>
                  </div>
                  <div class="col">
                    <label for="lastName" class="form-label"
                      >Last Name: <alzata-required-indicator
                    /></label>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="First"
                      v-model="firstName"
                      ref="firstName"
                      required
                      :disabled="busy"
                      data-lpignore="true"
                    />
                  </div>
                  <div class="col">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Last"
                      v-model="lastName"
                      ref="lastName"
                      required
                      :disabled="busy"
                      data-lpignore="true"
                    />
                  </div>
                </div>
              </div>
              <div class="form-group mb-2">
                <div class="row">
                  <div class="col">
                    <label for="email" class="form-label"
                      >Email Address: <alzata-required-indicator
                    /></label>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <input
                      type="text"
                      class="form-control"
                      v-model="email"
                      required
                      :disabled="busy"
                      data-lpignore="true"
                    />
                  </div>
                </div>
              </div>
              <!-- <div class="form-group mb-2">
                <div class="row">
                  <div class="col">
                    <label for="phone" class="form-label"
                      >Phone Number: <alzata-required-indicator
                    /></label>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <input
                      type="text"
                      class="form-control"
                      v-model="phoneNumber"
                      required
                      :disabled="busy"
                      data-lpignore="true"
                    />
                  </div>
                </div>
              </div> -->
              <!-- <div class="form-group mb-2">
                    <div class="row">
                        <div class="col">
                            <label for="phone" class="form-label">Username: <alzata-required-indicator /></label>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <input type="text"
                                class="form-control"
                                v-model="userName"
                                required
                                :disabled="busy"
                                data-lpignore="true"
                                readonly
                                />
                        </div>
                    </div>
                </div> -->
            </div>
          </alzata-tab>
          <alzata-tab title="Roles">
            <ul class="list-group small">
              <li
                v-for="(role, idx) in roles"
                :key="idx"
                class="list-group-item d-flex align-items-center py-0 pe-0 ps-2"
              >
                <span>{{ role }}</span>
                <div class="btn-group btn-group-sm" role="group">
                  <button
                    type="button"
                    class="btn btn-sm btn-default"
                    :disabled="role.principalTypeId === null"
                    @click="() => roles.splice(idx, 1)"
                  >
                    <alzata-icon icon="far/trash-alt" />
                  </button>
                </div>
              </li>
            </ul>
            <alzata-dropdown
              class="me-auto text-primary mt-1"
              size="sm"
              color="secondary"
              :items="availableRoles"
            >
              <template v-slot:label>
                <alzata-icon icon="far/plus-circle" fixed-width />
                <span class="mx-2">Add Role...</span>
              </template>
              <template v-slot:item="{ item }">
                <li>
                  <a class="dropdown-item" href="#" @click="addRole(item)">
                    {{ item.name }}
                    <!-- <alzata-icon :icon="iconForPrincipalTypeId(item.principalTypeId)" fixed-width />
                        {{nameForPrincipal(item.principalTypeId, item.principalId)}} -->
                  </a>
                </li>
              </template>
            </alzata-dropdown>
          </alzata-tab>
        </alzata-tabs>
      </div>
    </div>

    <template v-slot:modal-footer>
      <button type="button" class="btn btn-link" @click="this.$refs.modal.hide">
        Cancel
      </button>
      <button type="button" class="btn btn-primary" @click="saveUser">
        Save
      </button>
    </template>
  </alzata-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "AlzataEditUserDialog",
  emits: ["save"],
  data() {
    return {
      user: null,
      firstName: null,
      lastName: null,
      email: null,
      //phoneNumber: null,
      //username: null,
      roles: [],
      busy: false,
    };
  },
  mounted() {
    this.loadRoles();
  },
  computed: {
    ...mapState({
      allRoles: (state) => state.iam.allRoles,
    }),
    availableRoles() {
      if (this.allRoles) {
        const availableRoles = Object.values(this.allRoles).filter(
          (r) => this.roles.findIndex((i) => i === r.name) < 0
        );
        return availableRoles;
      }

      return [];
    },
  },
  methods: {
    show(user) {
      this.user = user;
      this.firstName = user.firstName;
      this.lastName = user.lastName;
      this.email = user.email;
      //this.phoneNumber = user.phoneNumber;
      //this.userName = user.userName;
      this.roles = user.roles;
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    saveUser() {
      const roleIds = Object.values(this.allRoles)
        .filter((r) => this.roles.includes(r.name))
        .map((r) => r.id);

      this.$emit("save", {
        id: this.user.id,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        //phoneNumber: this.phoneNumber,
        userName: this.userName,
        roles: roleIds,
      });
    },
    addRole(role) {
      this.roles.push(role.name);
    },
    ...mapActions("iam", ["loadRoles"]),
  },
};
</script>
